let SERVER_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  return JSON.parse(localStorage.getItem("key"));
};

const getUserId = () => {
  return Number(localStorage.getItem("userId"));
};

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  authorization: "",
};

export const httpGetGroups = () => {
  const endpoint = `api/group`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpGetGroupById = (id) => {
  const endpoint = `api/group/${id}`;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "GET",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpCreateGroup = (body) => {
  const endpoint = "api/group/create";
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "POST",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    body: JSON.stringify({
      ...body,
      created_by: getUserId(),
      updated_by: getUserId(),
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpDeleteGroup = (id) => {
  const endpoint = "api/group/" + id;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "DELETE",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
  })
    .then((res) => res.json())
    .then((data) => data);
};

export const httpUpdateGroup = (id, body) => {
  const endpoint = "api/group/" + id;
  const url = SERVER_URL + endpoint;
  return fetch(url, {
    method: "PUT",
    headers: { ...headers, authorization: `Bearer ${getToken()?.value}` },
    body: JSON.stringify({
      ...body,
      updated_by: getUserId(),
    }),
  })
    .then((res) => res.json())
    .then((data) => data);
};
